import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentsTypesService, DocumentType } from '../../services/documents-types.service';

@Component({
  selector: 'app-create-documents-types',
  templateUrl: './create-documents-types.component.html',
  styleUrls: ['./create-documents-types.component.css']
})
export class CreateDocumentsTypesComponent implements OnInit {
  documentsForm: FormGroup;
  documentId: string;
  constructor(
    private fb: FormBuilder,
    private sv: DocumentsTypesService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.documentId = this.route.snapshot.paramMap.get('id');
    //console.log();
    this.createForm();
  }

  ngOnInit() {
    if (this.documentId) {
      this.sv.getDocument(this.documentId).subscribe(data => {
        this.documentsForm.patchValue(data);
      })
    }
  }

  createForm() {
    this.documentsForm = this.fb.group({
      name: ['', Validators.required],
      folio: [0, Validators.required],
      description: ['', Validators.required],
    })
  }

  saveDocument({value, valid}: {value: DocumentType, valid: boolean}) {
    if (this.documentId) {
        this.sv.updateDocument(this.documentId, value);
    } else {
      this.sv.addDocument(value);
    }
    this.router.navigate(['documents']);
  }

  

}
